import { computed } from 'vue';
import { useCustomizedDeliveryStore } from '@/stores/customizedDelivery.js';
import { useTrackingDataStore } from '@/stores/trackingData.js';
import { useParcelShop } from '@/v2/components/map/useParcelShop.js';

export const useShowCustomize = () => {
  const customizedDeliveryStore = useCustomizedDeliveryStore();
  const trackingDataStore = useTrackingDataStore();
  const { isRedirectedToParcelShop } = useParcelShop();

  const isEligibleForCustomize = computed(() => {
    return (
      !customizedDeliveryStore.customizedDelivery &&
      trackingDataStore.supportedCustomizedDeliveryTypes?.length > 0 &&
      !isRedirectedToParcelShop.value
    );
  });

  return {
    isEligibleForCustomize
  };
};
